import React from 'react'
import { LayoutBand, colors, Bleed, Divider } from '@fs/zion-ui'
import PanelHeaderLayoutBand from './PanelHeaderLayoutBand'

const DEFAULT_HEADING_SIZE = 'H5'

const PanelHeader = ({ heading, caption, headingSize = DEFAULT_HEADING_SIZE, children }) => {
  return (
    <Bleed top>
      <Divider fullWidth />
      <PanelHeaderLayoutBand heading={heading} caption={caption} headingSize={headingSize} />
      {children && (
        <LayoutBand color={colors.white100} marginY="xs">
          {children}
        </LayoutBand>
      )}
    </Bleed>
  )
}

export default PanelHeader
